import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.css";

function HomePage() {
  const images = [
    "https://floriakw.com/wp-content/uploads/2025/06/WhatsApp-Image-2025-06-10-at-13.30.36.jpeg",
    "https://floriakw.com/wp-content/uploads/2025/06/WhatsApp-Image-2025-06-10-at-13.30.37.jpeg",
    "https://floriakw.com/wp-content/uploads/2025/06/WhatsApp-Image-2025-06-10-at-13.30.38.jpeg",
    "https://floriakw.com/wp-content/uploads/2025/06/WhatsApp-Image-2025-06-10-at-13.30.37-1.jpeg",
  ];

  // Desktop/Tablet carousel settings
  const desktopSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    swipeToSlide: true,
    touchThreshold: 10,
    touchMove: true,
    draggable: true,
    pauseOnHover: true,
    centerMode: false,
    centerPadding: '0',
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  // Mobile-only carousel settings
  const mobileSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    swipeToSlide: true,
    touchThreshold: 10,
    touchMove: true,
    draggable: true,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: '20px'
  };

  return (
    <section className="hero-carousel">
      <div className="carousel-container">
        {/* Desktop/Tablet carousel */}
        <div className="desktop-only">
          <Slider {...desktopSettings}>
            {images.map((img, index) => (
              <div key={index} className="carousel-slide">
                <div className="slide-content">
                  <img
                    src={img}
                    alt={`Slide ${index}`}
                    className="slider-image"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Mobile carousel */}
        <div className="mobile-only">
          <Slider {...mobileSettings}>
            {images.map((img, index) => (
              <div key={index} className="carousel-slide">
                <div className="slide-content">
                  <img
                    src={img}
                    alt={`Slide ${index}`}
                    className="slider-image"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default HomePage;
